import UniteResourceBlockView from './View';

export const UniteResourceBlockEdit = (props) => {
  return <UniteResourceBlockView {...props} />;
};

export default UniteResourceBlockEdit;
